import { List, ListSubheader, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'shared/types';
import { Wildfire } from 'features/wildfires/wildfire.types';
import LinkItem from 'components/LinkItem';
import { BroadcastifyFeeds } from 'features/broadcastify/components/BroadcastifyFeeds';
import { CoordinatesList } from './CoordinatesList';

type StructuredInfoProps = {
  wildfire: Wildfire;
};

type LinksListProps = {
  links: Link[];
};

const LinksList = (props: LinksListProps): JSX.Element => {
  const { links } = props;
  const { t } = useTranslation();

  return (
    <List
      subheader={
        <ListSubheader
          color="inherit"
          disableSticky
          sx={(theme) => ({
            padding: theme.spacing(3, 2, 2),
            lineHeight: 1,
            borderBottom: `1px solid ${theme.palette.divider}`,
          })}
        >
          <Typography variant="h3" sx={{ fontWeight: 'fontWeightBold' }}>
            {t('geoEvent.structuredInfo.links')}
          </Typography>
        </ListSubheader>
      }
    >
      {links.map((link) => (
        <LinkItem key={`${link.label}-${link.value}`} link={link} />
      ))}
    </List>
  );
};

export const WildfireStructuredInfo = (
  props: StructuredInfoProps,
): JSX.Element => {
  const { wildfire } = props;

  const links = wildfire.data?.links ?? [];

  return (
    <>
      <CoordinatesList wildfire={wildfire} />

      <BroadcastifyFeeds lat={wildfire.lat} lng={wildfire.lng} />

      {links.length > 0 && <LinksList links={links} />}
    </>
  );
};
